class AssetService {
  constructor() {}

  private get baseUrl(): string {
    return import.meta.env.BASE_URL || "/";
  }

  getLocalePath(): string {
    return this.baseUrl + "assets/{{lng}}.json";
  }

  getImagePath(imageName: string): string {
    return this.baseUrl + "assets/" + imageName;
  }
}

export const assetService = new AssetService();
